import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { EventEmitter, ViewContainerRef } from '@angular/core';
import { Deferred } from '../../../classes/deferred';
import { LayerService } from '../../../services/layer.service';
import { BaseComponent } from '../../base.component';
var ImportExternalMapComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ImportExternalMapComponent, _super);
    function ImportExternalMapComponent(_vcr, http, layerService) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.http = http;
        _this.layerService = layerService;
        _this.done = new EventEmitter();
        _this.loading = false;
        _this.layers = [];
        return _this;
    }
    Object.defineProperty(ImportExternalMapComponent.prototype, "agolMapUrl", {
        get: function () {
            return this._agolMapUrl;
        },
        set: function (url) {
            this._agolMapUrl = url;
            if (url) {
                try {
                    this.mapURL = new URL(this._agolMapUrl);
                    this.setMapVariables();
                }
                catch (_a) {
                    this.mapURL = null;
                    this.errorMessage = 'Invalid URL';
                }
            }
            else {
                this.mapURL = null;
                this.webMapId = null;
                this.mapJsonUrl = null;
                this.errorMessage = '';
                this.layers = [];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImportExternalMapComponent.prototype, "selectedLayers", {
        get: function () {
            return this.layers.filter(function (l) { return l.selected; });
        },
        enumerable: true,
        configurable: true
    });
    ImportExternalMapComponent.prototype.setMapVariables = function () {
        this.errorMessage = '';
        this.setWebMapId();
        this.setMapJsonUrl();
    };
    ImportExternalMapComponent.prototype.setWebMapId = function () {
        var e_1, _a;
        this.webMapId = null;
        if (this.mapURL) {
            try {
                for (var _b = tslib_1.__values(['id', 'webmap']), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var param = _c.value;
                    if (this.mapURL.searchParams.has(param)) {
                        this.webMapId = this.mapURL.searchParams.get(param).trim();
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    };
    ImportExternalMapComponent.prototype.setMapJsonUrl = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.layers = [];
                        if (!(this.webMapId && this.mapURL)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getAGOLMapData()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!this.mapURL) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getMapData()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.populateLayerData();
                        return [2 /*return*/];
                }
            });
        });
    };
    ImportExternalMapComponent.prototype.getAGOLMapData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var complete;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        complete = new Deferred();
                        this.mapJsonUrl = this.mapURL.protocol + "//" + this.mapURL.host + "/sharing/rest/content/items/" + this.webMapId + "/data?f=json";
                        this.loading = true;
                        try {
                            this.http.get(this.mapJsonUrl).subscribe(function (result) {
                                _this.loading = false;
                                try {
                                    if (result.operationalLayers) {
                                        _this.layers = result.operationalLayers.map(function (ol) { return ({ name: ol.title, url: ol.url, id: ol.id, selected: true }); });
                                    }
                                    else if (result.featureCollection) {
                                        _this.layers = result.featureCollection.layers.map(function (ol) { return ({ name: ol.title, url: ol.url, id: ol.id, selected: true }); });
                                    }
                                    complete.resolve();
                                }
                                catch (_a) {
                                    _this.errorMessage = 'Could not get map data from URL';
                                    complete.resolve();
                                }
                            }, function (er) {
                                _this.errorMessage = er && er.message.toLowerCase().startsWith('http') && _this.mapJsonUrl.toLowerCase().startsWith('http:')
                                    ? 'Content security issue. Try changing the map address to HTTPS instead of HTTP.'
                                    : 'Could not get map data from URL';
                                _this.loading = false;
                                complete.resolve();
                            });
                        }
                        catch (_b) {
                            this.loading = false;
                            this.errorMessage = 'Could not get map data from URL';
                            complete.resolve();
                        }
                        return [4 /*yield*/, complete.promise];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ImportExternalMapComponent.prototype.getMapData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var complete;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        complete = new Deferred();
                        this.addJSONTypeToURL(this.mapURL);
                        this.loading = true;
                        try {
                            this.http.get(this.mapURL.toString()).subscribe(function (result) {
                                _this.loading = false;
                                try {
                                    _this.layers = result.layers.map(function (l) {
                                        var url = new URL(_this.mapURL.toString());
                                        url.pathname += "/" + l.id;
                                        return { name: l.name, id: l.id, url: url.toString(), selected: true };
                                    });
                                    complete.resolve();
                                }
                                catch (_a) {
                                    _this.errorMessage = 'Could not get map data from URL';
                                    complete.resolve();
                                }
                            }, function (_er) {
                                _this.errorMessage = 'Could not get map data from URL';
                                _this.loading = false;
                                complete.resolve();
                            });
                        }
                        catch (_b) {
                            this.loading = false;
                            this.errorMessage = 'Could not get map data from URL';
                            complete.resolve();
                        }
                        return [4 /*yield*/, complete.promise];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ImportExternalMapComponent.prototype.populateLayerData = function () {
        var e_2, _a;
        if (this.layers.length) {
            var _loop_1 = function (layer) {
                var url = new URL(layer.url);
                this_1.addJSONTypeToURL(url);
                this_1.http.get(url.toString()).subscribe(function (result) {
                    layer.description = result.description;
                    layer.data = result;
                    if (!layer.data.url) {
                        layer.data.url = url.toString();
                    }
                });
            };
            var this_1 = this;
            try {
                for (var _b = tslib_1.__values(this.layers), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var layer = _c.value;
                    _loop_1(layer);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    };
    ImportExternalMapComponent.prototype.addJSONTypeToURL = function (url) {
        if (!url.searchParams.has('f')) {
            url.searchParams.append('f', 'json');
        }
        else if (url.searchParams.get('f') !== 'json') {
            url.searchParams.set('f', 'json');
        }
    };
    ImportExternalMapComponent.prototype.addToMap = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layerResults, _a, _b, _c;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.esriMap = null;
                        this.errorMessage = '';
                        layerResults = this.selectedLayers.filter(function (l) { return l.data; }).map(function (l) { return l.data; });
                        if (!(layerResults.length !== this.selectedLayers.length)) return [3 /*break*/, 2];
                        _b = (_a = layerResults.push).apply;
                        _c = [layerResults];
                        return [4 /*yield*/, Promise.all(this.selectedLayers.filter(function (l) { return !l.data; }).map(function (layer) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.layerService.getExternalLayerSymbolData(layer)];
                                        case 1: return [2 /*return*/, _a.sent()];
                                    }
                                });
                            }); }))];
                    case 1:
                        _b.apply(_a, _c.concat([tslib_1.__spread.apply(void 0, [(_d.sent())])]));
                        _d.label = 2;
                    case 2: return [4 /*yield*/, Promise.all(layerResults.filter(function (r) { return r; }).map(function (layerResult) {
                            layerResult.featureEndpoints = [{ url: layerResult.url }];
                            layerResult.name = layerResult.name || layerResult.title;
                            return _this.layerService.addExternalLayersToMap(layerResult);
                        }))];
                    case 3:
                        _d.sent();
                        this.done.emit(true);
                        return [2 /*return*/];
                }
            });
        });
    };
    ImportExternalMapComponent.prototype.close = function () {
        this.done.emit(true);
    };
    ImportExternalMapComponent.prototype.toggleAllLayers = function () {
        var selectAll = this.selectedLayers.length !== this.layers.length;
        this.layers.forEach(function (l) { return l.selected = selectAll; });
    };
    return ImportExternalMapComponent;
}(BaseComponent));
export { ImportExternalMapComponent };
